/* Cervi-Zen™ — panier tiroir maison (remplace UpCart) · v1.2 2026-10-13 (rendu v1 + upsell en lignes compactes)
   v1.1 = vitesse seulement : ouverture immédiate au toucher (panier pré-rempli depuis la formule Rapi cochée, confirmé ensuite
          par /cart.js), et plus jamais d'affichage intermédiaire « cadeaux seuls » pendant les ajouts Rapi.
   Rendu par snippets/cz-cart-drawer.liquid. API : window.CZCart.open() / close() / add(items) / refresh()
   Règles : toujours relire /cart.js après un ajout/changement (Rapid Bundle modifie le panier),
            ne jamais envoyer cart.attributes (fbp/fbc WeTracked), jamais /cart/clear. */
(function () {
  'use strict';
  if (window.CZCart && window.CZCart._ready) return;
  var root = document.getElementById('CZCart');
  var cfgEl = document.getElementById('CZCart-config');
  if (!root || !cfgEl) return;
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var R = CFG.root || '/';
  /* CZ multilangue 23/10/2026 : hors FR, routes.root_url vaut "/de" (sans barre finale) -> on ajoute la barre, sinon les appels partent sur /decart.js (404). FR ("/") inchangé. */
  if (R.charAt(R.length - 1) !== '/') R += '/';
  var THRESH = +CFG.freeShipping || 0;
  /* CZ multilangue 23/10/2026 : textes traduits lus dans window.CZ_CART_I18N (rempli en Liquid pour de/es/it par snippets/cz-cart-drawer.liquid).
     Clé absente (FR, autres langues) = texte français d'origine, au caractère près. {x} = valeur insérée. */
  function T(k, d) { var I = window.CZ_CART_I18N; return I && typeof I[k] === 'string' ? I[k] : d; }
  function TX(k, d, x) { return T(k, d).replace('{x}', function () { return x; }); }

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || root).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var fmt;
  try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CFG.currency || 'EUR' }); } catch (e) { fmt = null; }
  function money(c) { c = (+c || 0) / 100; return fmt ? fmt.format(c) : c.toFixed(2).replace('.', ',') + ' €'; }
  function img(u, w) {
    if (!u) return '';
    try { var x = new URL(u, location.origin); x.searchParams.set('width', w); return x.toString(); } catch (e) { return u; }
  }
  var ICON_TAG = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var ICON_BIN = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>';

  /* ---------- requêtes (passent par window.fetch pour que Rapi/Kaching voient nos appels) ---------- */
  var selfN = 0; // >0 pendant que NOUS appelons fetch (lu de façon synchrone par l'observateur)
  function req(path, body) {
    var opt = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (body) {
      if (body instanceof FormData) opt.body = body;
      else { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    }
    selfN++;
    var p;
    try { p = window.fetch(R + path, opt); } finally { selfN--; }
    return p.then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || T('err', 'Erreur panier')); e.data = j; throw e; }
        return j;
      });
    });
  }

  /* ---------- prix barrés : compare_at des variantes (cache par produit) ---------- */
  var cmpCache = {}; // handle -> Promise<{variantId: compare_at}>
  var cmpAll = {};   // variantId -> compare_at (tout ce qui est déjà connu)
  var prodInfo = {}; // handle -> produit (/products/x.js) pour le pré-remplissage instantané
  function compareFor(handle) {
    if (!handle) return Promise.resolve({});
    if (!cmpCache[handle]) {
      selfN++;
      var p;
      try { p = window.fetch(R + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }); } finally { selfN--; }
      cmpCache[handle] = p.then(function (r) { return r.ok ? r.json() : { variants: [] }; }).then(function (pr) {
        if (pr && pr.id) prodInfo[handle] = pr;
        var m = {}; (pr.variants || []).forEach(function (v) { m[v.id] = cmpAll[v.id] = +v.compare_at_price || 0; });
        if (cart) render(); // réponse arrivée après l'affichage : on remet les prix barrés
        return m;
      }).catch(function () { return {}; });
    }
    return cmpCache[handle];
  }
  function compareMap(cart) {
    var hs = {}; cart.items.forEach(function (i) { hs[i.handle] = 1; });
    var all = Object.keys(hs).map(compareFor);
    var t = new Promise(function (res) { setTimeout(function () { res(null); }, 1500); });
    return Promise.race([Promise.all(all), t]).then(function () { return cmpAll; });
  }

  /* ---------- état ---------- */
  var cart = null, cmp = cmpAll, seq = 0, optActive = false, optCart = null;
  var els = {
    count: $('[data-czc-count]'), ship: $('[data-czc-ship]'), shipMsg: $('[data-czc-ship-msg]'), bar: $('[data-czc-bar]'),
    items: $('[data-czc-items]'), up: $('[data-czc-up]'), upGrid: $('[data-czc-up-grid]'), empty: $('[data-czc-empty]'),
    ft: $('[data-czc-ft]'), sub: $('[data-czc-sub]'), discs: $('[data-czc-discs]'), total: $('[data-czc-total]'),
    tsave: $('[data-czc-tsave]'), err: $('[data-czc-err]'), panel: $('.czc-panel'), body: $('[data-czc-body]')
  };

  function refresh() {
    var my = ++seq;
    return req('cart.js').then(function (c) {
      return compareMap(c).then(function (m) {
        if (my !== seq) return cart; // une relecture plus récente a eu lieu
        cart = c; cmp = m; if (!optActive) render(); bubble(); return cart;
      });
    });
  }

  function showErr(msg) {
    els.err.textContent = msg || '';
    els.err.classList.toggle('on', !!msg);
  }

  /* ---------- rendu ---------- */
  function lineHTML(it) {
    var cmpUnit = cmp[it.variant_id] || 0;
    var was = Math.max(it.original_line_price || 0, cmpUnit * it.quantity);
    var now = it.final_line_price;
    var save = was - now;
    var gift = now === 0; // cadeau auto (Rapi) ou ligne offerte : pas de +/− ni poubelle
    var tags = {};
    (it.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title; if (t) tags[t] = 1;
    });
    var meta = [];
    if (!it.product_has_only_default_variant && it.variant_title) meta.push(esc(it.variant_title));
    var pr = it.properties || {};
    for (var k in pr) { if (pr[k] !== '' && pr[k] != null && k.charAt(0) !== '_') meta.push(esc(k) + ' : ' + esc(pr[k])); }
    var h = '<li class="czc-it" data-key="' + esc(it.key) + '">';
    h += '<a class="czc-img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="84" height="84">' : '') + '</a>';
    h += '<div class="czc-info"><div class="czc-top"><div><a class="czc-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>';
    if (meta.length) h += '<div class="czc-var">' + meta.join(' · ') + '</div>';
    h += '</div>';
    if (!gift) h += '<button type="button" class="czc-del" data-czc-del aria-label="' + TX('remove', 'Retirer {x} du panier', esc(it.product_title)) + '">' + ICON_BIN + '</button>';
    h += '</div>';
    Object.keys(tags).forEach(function (t) { h += '<span class="czc-tag">' + ICON_TAG + esc(t) + '</span>'; });
    h += '<div class="czc-bot">';
    if (gift) {
      h += '<span class="czc-var">' + T('qty', 'Quantité : ') + it.quantity + '</span>';
    } else {
      h += '<div class="czc-qty"><button type="button" data-czc-q="-1" aria-label="' + T('dec', 'Diminuer la quantité') + '">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-czc-q="1" aria-label="' + T('inc', 'Augmenter la quantité') + '">+</button></div>';
    }
    h += '<div class="czc-pr">';
    if (now === 0) {
      if (was > 0) h += '<s class="czc-was">' + money(was) + '</s>';
      h += '<span class="czc-free">' + T('free', 'Offert') + '</span>';
    } else {
      if (save > 0) h += '<s class="czc-was">' + money(was) + '</s>';
      h += '<span class="czc-now">' + money(now) + '</span>';
      if (save > 0) h += '<span class="czc-save">' + TX('save', '(Économie {x})', money(save)) + '</span>';
    }
    h += '</div></div></div></li>';
    return h;
  }

  function render() {
    var real = cart;
    if (optActive && optCart) cart = optCart;
    try { renderCart(); } finally { cart = real; }
    var co = $('[data-czc-checkout]');
    if (co) { co.style.opacity = optActive ? '.55' : ''; co.style.pointerEvents = optActive ? 'none' : ''; }
  }
  function renderCart() {
    if (!cart) return;
    var n = cart.item_count || 0;
    els.count.textContent = n;
    var empty = !cart.items.length;
    els.empty.hidden = !empty;
    els.ft.hidden = empty;
    els.ship.hidden = empty || !THRESH;

    /* barre livraison (sur le total après remises) */
    if (THRESH && !empty) {
      var tot = cart.total_price, left = THRESH - tot, ok = left <= 0;
      els.ship.classList.toggle('is-ok', ok);
      els.shipMsg.innerHTML = ok ? T('shipOk', 'Livraison offerte débloquée') : TX('shipLeft', 'Plus que <b>{x}</b> pour la livraison offerte', money(left));
      els.bar.style.width = Math.min(100, Math.max(4, tot * 100 / THRESH)) + '%';
    }

    /* lignes */
    els.items.innerHTML = cart.items.map(lineHTML).join('');

    /* upsells */
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var ups = (CFG.upsells || []).filter(function (u) { return !inCart[u.productId]; }).slice(0, CFG.upsellMax || 2);
    els.up.hidden = empty || !ups.length;
    els.upGrid.classList.toggle('one', ups.length === 1);
    els.upGrid.innerHTML = ups.map(function (u) {
      var pr = (u.compare > u.price ? '<s>' + money(u.compare) + '</s>' : '') + money(u.price);
      /* v1.2 : upsell en lignes compactes (photo · nom · prix · + Ajouter), demandé par Guilhem le 13/10 */
      return '<div class="czc-upr"><a class="czc-upr-img" href="' + esc(u.url) + '" tabindex="-1" aria-hidden="true">' + (u.image ? '<img src="' + esc(u.image) + '" alt="" width="40" height="40">' : '') + '</a>' +
        '<div class="czc-upr-t"><span class="czc-upr-n">' + esc(u.title) + '</span><span class="czc-upr-p">' + pr + '</span></div>' +
        '<button type="button" class="czc-upr-add" data-czc-up-add="' + u.variantId + '" aria-label="' + TX('upAdd', 'Ajouter {x} au panier', esc(u.title)) + '">' + T('upBtn', '+ Ajouter') + '</button></div>';
    }).join('');

    /* pied */
    if (!empty) {
      var lineSave = 0;
      cart.items.forEach(function (it) {
        var was = Math.max(it.original_line_price || 0, (cmp[it.variant_id] || 0) * it.quantity);
        if (was > it.final_line_price) lineSave += was - it.final_line_price;
      });
      var cartDisc = 0, dh = '';
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        var a = +d.total_allocated_amount || 0; if (!a) return; cartDisc += a;
        dh += '<div class="czc-row disc"><span>' + ICON_TAG + ' ' + esc(d.title) + '</span><b>−' + money(a) + '</b></div>';
      });
      /* pied : Sous-total · (remises panier) · Total (Économie X) — pas de ligne livraison (décision Guilhem 12/10) */
      els.sub.textContent = money(cart.items_subtotal_price);
      els.discs.innerHTML = dh;
      els.total.textContent = money(cart.total_price);
      var ts = lineSave + cartDisc;
      els.tsave.textContent = ts > 0 ? TX('save', '(Économie {x})', money(ts)) : '';
    }
  }

  /* pastille du panier dans l'en-tête du thème */
  function bubble() {
    if (!cart) return;
    var n = cart.item_count || 0;
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + '&nbsp;' + (n > 1 ? T('items', 'articles') : T('item', 'article')) + '</span>';
    });
    document.dispatchEvent(new CustomEvent('cz:cart:updated', { detail: cart }));
  }

  /* ---------- ouverture / fermeture / focus ---------- */
  var lastFocus = null, isOpen = false;
  function open() {
    if (!isOpen) {
      isOpen = true;
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var x = $('.czc-x'); x && x.focus({ preventScroll: true }); }, 60);
    }
    if (!cart) { root.classList.add('is-loading'); refresh().then(function () { root.classList.remove('is-loading'); }, function () { root.classList.remove('is-loading'); }); }
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    showErr('');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-czc-close]')) { e.preventDefault(); close(); } });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = [].filter.call(els.panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* ---------- actions ---------- */
  function setBusy(li, on) { if (li) li.classList.toggle('is-busy', on); }
  function change(key, qty, li) {
    setBusy(li, true); showErr('');
    return req('cart/change.js', { id: key, quantity: qty })
      .catch(function (e) { showErr(e.message); })
      .then(refresh)
      .then(function () { setBusy(li, false); }, function () { setBusy(li, false); });
  }
  els.items.addEventListener('click', function (e) {
    var li = e.target.closest('.czc-it'); if (!li || !cart) return;
    var key = li.getAttribute('data-key');
    var it = cart.items.filter(function (i) { return i.key === key; })[0]; if (!it) return;
    if (e.target.closest('[data-czc-del]')) { change(key, 0, li); return; }
    var q = e.target.closest('[data-czc-q]');
    if (q) { change(key, Math.max(0, it.quantity + (+q.getAttribute('data-czc-q'))), li); }
  });
  els.upGrid.addEventListener('click', function (e) {
    var b = e.target.closest('[data-czc-up-add]'); if (!b) return;
    b.disabled = true; b.textContent = T('adding', 'Ajout…');
    add([{ id: +b.getAttribute('data-czc-up-add'), quantity: 1, properties: { _cz_upsell: 'drawer' } }])
      .catch(function () {}).then(function () { b.disabled = false; b.textContent = T('upBtn', '+ Ajouter'); });
  });

  /* ajout : items = [{id, quantity, properties?}] ou FormData. Relit toujours /cart.js puis ouvre. */
  function add(items) {
    showErr('');
    var body = items instanceof FormData ? items : { items: items };
    root.classList.add('is-loading');
    return req('cart/add.js', body)
      .then(function (r) { lastUser = Date.now(); return refresh().then(function () { open(); settle(); return r; }); })
      .catch(function (e) { return refresh().catch(function () {}).then(function () { open(); showErr(e.message); throw e; }); })
      .then(function (r) { root.classList.remove('is-loading'); return r; }, function (e) { root.classList.remove('is-loading'); throw e; });
  }
  /* Rapi ajoute ses cadeaux juste après : 2e relecture différée */
  var settleT;
  function settle() { clearTimeout(settleT); settleT = setTimeout(function () { refresh().catch(function () {}); }, 1200); }

  /* ---------- observateur : ajouts faits par le thème / les apps ---------- */
  var lastUser = 0;
  ['pointerdown', 'keydown', 'submit', 'touchstart'].forEach(function (t) { document.addEventListener(t, function () { lastUser = Date.now(); }, true); });
  function recentUser() { return Date.now() - lastUser < 6000; }
  var extT, extAdd = false, extPending = 0, extTries = 0, extStart = 0;
  /* Rapi ajoute d'abord ses cadeaux, puis l'oreiller : panier « cadeaux seuls » = état transitoire, jamais affiché */
  function giftsOnly(c) {
    if (!c || !c.items.length) return false;
    return c.items.every(function (i) { var o = i.properties && i.properties.__rapi_offer; return o && String(o).indexOf('"gift":true') > -1; });
  }
  function endOpt() {
    if (!optActive) return;
    optActive = false; optCart = null; render();
  }
  function onExternal(isAdd) {
    extAdd = extAdd || isAdd;
    clearTimeout(extT);
    extT = setTimeout(function () {
      if (extPending > 0 && (!extStart || Date.now() - extStart < 8000)) { onExternal(false); return; }
      var a = extAdd;
      refresh().then(function (c) {
        if (a && giftsOnly(c) && extTries < 6) { extTries++; onExternal(false); return; }
        extAdd = false; extTries = 0; extStart = 0;
        endOpt();
        if (a && recentUser() && !(window.CZCart && window.CZCart.quiet)) { open(); settle(); }
      }).catch(function () { extAdd = false; extTries = 0; extStart = 0; endOpt(); });
    }, 120);
  }
  setInterval(function () { if (optActive && extStart && Date.now() - extStart > 8000) { extStart = 0; endOpt(); refresh().catch(function () {}); } }, 1000);

  /* Ouverture immédiate : au toucher « Ajouter au panier », le tiroir s'ouvre déjà rempli (même rendu que le vrai panier),
     à partir de la formule Rapi cochée + des fiches produits préchargées. Le vrai panier remplace ce rendu dès que Rapi a fini. */
  function euro(t) { var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{1,2})?)/); return m ? Math.round(parseFloat(m[1].replace(',', '.')) * 100) : 0; }
  var GIFTS = [{ re: /livraison/i, handle: 'livraison-premium' }, { re: /satin/i, handle: 'housse-satin-platine™-fibre-deucalyptus-satinee' }];
  function pageHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function optItem(pr, variantId, qty, linePrice, tag, key) {
    var v = (pr.variants || []).filter(function (x) { return x.id == variantId; })[0] || (pr.variants || [])[0] || {};
    var im = (v.featured_image && v.featured_image.src) || pr.featured_image || '';
    if (im && im.indexOf('//') === 0) im = 'https:' + im;
    return { key: key, product_id: pr.id, variant_id: v.id, handle: pr.handle, url: '/products/' + pr.handle, image: im, product_title: pr.title,
      product_has_only_default_variant: (pr.variants || []).length < 2, variant_title: v.title, properties: {}, quantity: qty,
      original_line_price: (+v.price || 0) * qty, final_line_price: linePrice,
      line_level_discount_allocations: tag ? [{ discount_application: { title: tag } }] : [] };
  }
  function optimistic(form) {
    if (!cart || !form) return false;
    var bar = null;
    [].forEach.call(document.querySelectorAll('input[name^="rapi-bundles-deal"]'), function (r) { if (r.checked) bar = r.closest('.rapi-bundles__bar'); });
    var pr = prodInfo[pageHandle()];
    if (!bar || !pr) return false;
    var price = euro((bar.querySelector('.rapi-bundles__bar-price') || {}).textContent);
    var title = ((bar.querySelector('.rapi-bundles__bar-title') || {}).textContent || '').trim();
    var mq = title.match(/(\d+)\s*[×x]/), qty = mq ? +mq[1] : 1;
    if (!price) return false;
    var tag = qty > 1 ? title : '';
    var idEl = form.querySelector('[name="id"]');
    var items = [optItem(pr, idEl ? idEl.value : 0, qty, price, tag, 'cz-opt')];
    var gl = bar.innerText.split('\n').map(function (x) { return x.trim(); }).filter(function (x) { return x.charAt(0) === '+'; });
    var giftItems = [];
    GIFTS.forEach(function (g, k) {
      gl.forEach(function (line) {
        if (!g.re.test(line)) return;
        var gp = prodInfo[g.handle]; if (!gp) return;
        var gm = line.match(/^\+\s*(\d+)/), gq = gm ? +gm[1] : 1;
        giftItems.push(optItem(gp, 0, gq, 0, tag, 'cz-opt-g' + k));
      });
    });
    if (giftItems.length !== gl.length) return false; // cadeau inconnu : on attend le vrai panier
    items = items.concat(giftItems, cart.items);
    var add = qty + giftItems.reduce(function (a, i) { return a + i.quantity; }, 0);
    optCart = { items: items, item_count: (cart.item_count || 0) + add, total_price: (cart.total_price || 0) + price,
      items_subtotal_price: (cart.items_subtotal_price || 0) + price, cart_level_discount_applications: cart.cart_level_discount_applications || [] };
    optActive = true; extStart = Date.now();
    render(); open();
    return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('product-form [type="submit"], product-form button[name="add"]');
    if (!b || b.disabled || (window.CZCart && window.CZCart.quiet)) return;
    lastUser = Date.now();
    try { optimistic(b.closest('form')); } catch (err) { optActive = false; optCart = null; }
  }, true);
  var CART_RE = /\/cart\/(add|change|update)(\.js|\.json)?(\?|$)/;
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var mine = selfN > 0;
      var p = _f.apply(this, arguments);
      if (!mine && CART_RE.test(url)) {
        var isAdd = /\/cart\/add/.test(url);
        extPending++; if (isAdd && !extStart) extStart = Date.now();
        p.then(function (r) { extPending = Math.max(0, extPending - 1); onExternal(isAdd && !!(r && r.ok)); },
               function () { extPending = Math.max(0, extPending - 1); onExternal(false); });
      }
      return p;
    };
  }
  (function () {
    var X = window.XMLHttpRequest; if (!X) return;
    var o = X.prototype.open, s = X.prototype.send;
    X.prototype.open = function (m, u) { this._czUrl = u; return o.apply(this, arguments); };
    X.prototype.send = function () {
      var x = this, u = String(x._czUrl || '');
      if (CART_RE.test(u)) {
        var isAdd = /\/cart\/add/.test(u);
        extPending++; if (isAdd && !extStart) extStart = Date.now();
        x.addEventListener('loadend', function () { extPending = Math.max(0, extPending - 1); onExternal(isAdd && x.status >= 200 && x.status < 300); });
      }
      return s.apply(this, arguments);
    };
  })();

  /* le tiroir natif du thème (Shrine <cart-drawer>) délègue au nôtre */
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer'); if (!C) return;
      /* n'ouvre que suite à une action de l'acheteur (le thème appelle parfois open() tout seul au chargement) */
      C.prototype.open = function () { onExternal(false); if (recentUser()) open(); };
      C.prototype.renderContents = function () { onExternal(true); };
    });
  }

  /* icône panier de l'en-tête + liens marqués */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble, .header__icon--cart, [data-cz-cart-open]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
    refresh().catch(function () {});
  }, true);

  /* formulaires d'ajout qui ne sont pas gérés par le JS du thème (<product-form>) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (f.closest('product-form') || f.hasAttribute('data-cz-native')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(f);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    add(fd).catch(function () {});
  }, true);

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().catch(function () {}); });

  /* API publique */
  window.CZCart = { _ready: true, open: open, close: close, add: add, refresh: refresh, get cart() { return cart; } };
  document.dispatchEvent(new CustomEvent('cz:cart:ready'));

  /* préchargement discret (le tiroir s'ouvre plein dès le premier clic) */
  (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(function () { refresh().catch(function () {}); });
  /* préchargement des fiches (produit de la page + cadeaux Rapi) pour l'ouverture immédiate */
  if (document.querySelector('product-form')) {
    var ph = pageHandle(); if (ph) compareFor(ph);
    GIFTS.forEach(function (g) { compareFor(g.handle); });
  }
})();
